import { apiFetch, ApiBaseUrl } from "./fetch";

function pipelineHeaders() {
  const token = localStorage.getItem("id_token");
  return token ? { "X-RedFast-Token": token } : {};
}

export default class ApiFigma {
  static connectUrl(appId) {
    return `${ApiBaseUrl}apps/${appId}/figma/connect`;
  }

  static savePlanToken(appId, planToken) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/figma/plan_token`, {
      method: "PATCH",
      body: { plan_token: planToken },
    });
  }

  static disconnect(appId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/figma/disconnect`, {
      method: "DELETE",
    });
  }

  static createPipeline(
    appId,
    { name, figmaUrl, mobileFigmaUrl, pathId, pathGroupId, pathType, deviceType },
  ) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/figma/pipeline`, {
      method: "POST",
      body: {
        name,
        figma_url: figmaUrl || undefined,
        mobile_figma_url: mobileFigmaUrl || undefined,
        path_id: pathId || undefined,
        path_group_id: pathGroupId,
        path_type: pathType,
        device_type: deviceType,
      },
      headers: pipelineHeaders(),
    });
  }

  static refinePipeline(appId, { pathId, figmaUrl, mobileFigmaUrl }) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/figma/pipeline_refine`, {
      method: "POST",
      body: {
        path_id: pathId,
        figma_url: figmaUrl || undefined,
        mobile_figma_url: mobileFigmaUrl || undefined,
      },
      headers: pipelineHeaders(),
    });
  }

  static getPipelineJob(appId, workflowId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/figma/pipeline/${workflowId}`, {
      headers: pipelineHeaders(),
    });
  }
}
